import { ReactNode } from "react";

export interface FlashlightIconProps {
    state: boolean;
    width?: number;
    height?: number;
    color?: string;
}

export const FlashlightIcon = (props: FlashlightIconProps): ReactNode => {
    return (
        <svg
            width={props.width ?? 24}
            height={props.height ?? 24}
            focusable="false"
            aria-hidden="true"
            viewBox="0 0 24 24"
            fill={props.color}
        >
            {props.state ? (
                <path
                    d="M6 2h12v3H6zm0 5v1l2 3v11h8V11l2-3V7H6zm6 8.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                    fill={props.color}
                />
            ) : (
                <path
                    d="M18 5V2H6v1.17L7.83 5zm-2 6 2-3V7H9.83L16 13.17zM2.81 2.81 1.39 4.22 8 10.83V22h8v-3.17l3.78 3.78 1.41-1.41L2.81 2.81z"
                    fill={props.color}
                />
            )}
        </svg>
    )
}